import React, { ReactNode, ReactElement } from 'react';
import styled from '@emotion/styled';
import { INPUT_LABEL, INPUT_ERROR } from '../Style/input';
import {
  AutoSaveIndicator,
  AutoSaveState,
} from '../AutoSaveIndicator/component';

const InputLabelContainer = styled.div();

const Label = styled.label(INPUT_LABEL);
const Error = styled.span(INPUT_ERROR);

interface InputLabelProps {
  children: ReactNode;
  htmlFor?: string | undefined;
  error?: string | null;
  required?: boolean;

  // autoSave prop enable the auto-save indicator (loading/saving states)
  // autoSaveState does not do anything if autoSave is not defined or false
  // the reason of having a separate prop (autoSave) is because the "role=status"
  // element has to be rendered on page load, otherwise it would work properly
  // with screen readers
  autoSave?: boolean;
  autoSaveState?: AutoSaveState;
}

export const InputLabel = ({
  children,
  htmlFor = undefined,
  error,
  required = false,
  autoSave = false,
  autoSaveState,
}: InputLabelProps): ReactElement => (
  <InputLabelContainer>
    <Label htmlFor={htmlFor}>
      {children}
      {required && <span className="ol-text-field-required"> (required)</span>}
      {autoSave && (
        <>
          {' '}
          <AutoSaveIndicator state={autoSaveState} />
        </>
      )}
      {error && <Error>{error}</Error>}
    </Label>
  </InputLabelContainer>
);
